<template>
  <router-view />
</template>

<script>
import store, {
  name,
} from '@/modules/student-evaluation-request-managment/store';

export default {
  name: 'EvaluationRequestManagmentWrapper',
  created() {
    if (this.$store.state[name] == undefined) {
      this.$store.registerModule(name, store);
    }
    //Load all messages for module
    this.loadMessages(['0709', 'R90013', 'R03200109']);
  },
  destroyed() {
    this.$store.dispatch(`${name}/reset`); //Reset state
  },
};
</script>
